import React from 'react';
import styled from 'styled-components/macro'
import {ButtonColor, ButtonDownload, ButtonRuler} from './Buttons'

const StyledMenu = styled.div`
  position: absolute;
  right: 8px;
  top: 90px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-end;
`

const Menu = ({action, ruler}) => {
  return (
    <StyledMenu>
      <ButtonColor toogleColor={action.toogleColor} />
      <ButtonRuler ruler={ruler} handleClick={action.toggleRuler}/>
      <ButtonDownload handleClick={action.toggleExportModal}/>
    </StyledMenu>
  )
}

export default Menu;